import React, { memo, useMemo } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { FaSearchPlus } from 'react-icons/fa';
import { TbAlignBoxCenterMiddle } from 'react-icons/tb';
import TooltipUI from '../../../../UI/Tooltip/Tooltip';
import { useUtilStyles } from '../../../../../helpers';
import { IconButton } from '../../../../IconButton/IconButton';
import { TableWithAccordion } from './TableFichaClienteStyle';

function getAlignOption(row, column) {
  let alignOption = row.values[column.id] ? column.alignCell : 'center';
  if (!row.values[column.id] && column.showTip) {
    alignOption = 'center';
  }
  return alignOption;
}

function Row({
  row, columns, onInspecionar, onAcompanhamento,
}) {
  const styles = useUtilStyles();

  const getContent = (value, column) => {
    if (column.checkbox) {
      return value;
    }

    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom" interactive>
          <pre
            className={styles.overFlowText}
            style={{ maxWidth: column.maxWidth - 16 }}
          >
            {column.format && typeof value === 'number'
              ? column.format(value)
              : value}
          </pre>
        </TooltipUI>
      );
    }
    if (column.hiddenFullLine) {
      return (
        <pre
          className={styles.overFlowText}
          style={{ maxWidth: column.maxWidth - 16 }}
        >
          {column.format && typeof value === 'number'
            ? column.format(value)
            : value}
        </pre>
      );
    }
    return (
      <pre>
        {column.format && typeof value === 'number'
          ? column.format(value)
          : value}
      </pre>
    );
  };

  return (
    <>
      <TableRow className={styles.tableRowRoot}>
        {columns.map((column) => {
          if (column.isAction) {
            return (
              <TableCell
                key={column.id}
                style={{
                  height: '31px',
                  maxWidth: column.maxWidth,
                  minWidth: column.minWidth,
                  width: column.width,
                  borderTop: '1px solid #e0e0e0',
                  textAlign: 'center',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <IconButton
                    title="Inspecionar"
                    onClick={() => onInspecionar && onInspecionar(row.id)}
                  >
                    <FaSearchPlus size={14} color="black" />
                  </IconButton>
                  <IconButton
                    title="Acompanhamento"
                    onClick={() => onAcompanhamento && onAcompanhamento(row.id, row.nomeDoDevedor)}
                  >
                    <TbAlignBoxCenterMiddle size={15} color="black" />
                  </IconButton>
                </div>
              </TableCell>
            );
          }

          const value = row.values[column.id];
          const alignOption = getAlignOption(row, column);
          return (
            <TableCell
              key={column.id}
              style={{
                height: '31px',
                maxWidth: column.maxWidth,
                minWidth: column.minWidth,
                width: column.width,
                borderTop: '1px solid #e0e0e0',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: alignOption,
                }}
              >
                {getContent(value, column)}
              </div>
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

function TableFichaCliente({
  columns = [], rows = [], rowsPerPage, onInspecionar, onAcompanhamento,
}) {
  const columnLength = useMemo(() => columns.length + 1, [columns.length]);

  const buildEmptyRows = () => {
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length);

    const content = [];
    for (let i = 0; i < emptyRows; i += 1) {
      content.push(
        <TableRow key={i} style={{ height: 31 }}>
          <TableCell colSpan={columnLength}>
            <p />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  return (
    <>
      <TableWithAccordion>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  id={column.id}
                  key={column.id}
                  style={{
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth,
                    width: column.width,
                    textAlign: column.align,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <Row
                key={row.id}
                row={row}
                columns={columns}
                columnLength={columnLength}
                onInspecionar={onInspecionar}
                onAcompanhamento={onAcompanhamento}
              />
            ))}
            {buildEmptyRows()}
          </TableBody>
        </Table>
      </TableWithAccordion>
    </>
  );
}

export default memo(TableFichaCliente);
